import React, { Component } from 'react';
import { HashLink as HLink } from 'react-router-hash-link';
import homedata from '../../data/homedata.json';

class FeatureOne extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL;

    return (
      <section id="whychoseus" className="p-100px-tb featured-1 position-relative">
        <div className="bordered-circle2"></div>

        <div className="container">
          <div className="row align-items-center">

            <div className="col-sm-6 md-m-50px-b">
              <div className="feature1-img-wrap">
                <img
                  className="moveUpDown feature1-img"
                  src={publicUrl + homedata.feature1.imgurl1}
                  alt=""
                />
              </div>
            </div>

            <div className="col-sm-6">
              <div className="section-title">
                <h2 className="tlt1">{homedata.feature1.title}</h2>
              </div>

              <p style={{ whiteSpace: "pre-line" }}>
                {homedata.feature1.content}
              </p>

              {/* ✅ FIXED BUTTON */}
              <HLink
                smooth
                to={homedata.feature1.btn1url}
                className="my-custom-btn"
              >
                {homedata.feature1.btn1label}
              </HLink>

            </div>

          </div>
        </div>
      </section>
    );
  }
}

export default FeatureOne;